import { useQuery } from '@tanstack/react-query'

import { getSearchResults } from '#/local/service'

export const useSearchResult = (query: string) => useQuery({
    queryKey: ['search', query],
    queryFn: async ({ signal }) => getSearchResults(query, signal),
    enabled: query.length > 0,
})
